import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';
import { _post, _Alert } from './Function';
import Loading from './Loading';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import '../css/Register.css';

const $ = window.$;

class RegisterPassword extends Component {
    constructor(props) {
        super(props);
        this.state={ 
            password: '', 
            re_password: '', 
            show_password: false,
            show_re_password: false,
            loadingShow: false 
        };
    }

    static contextTypes = { router: PropTypes.object }

    update = (t, e) => {
        this.setState({ [t]: e.target.value });
    }

    eyeControlPassword() {
        if ( this.state.show_password ) {
            $("#new-password").removeClass("set-password");       
            return <i className="far fa-eye i-show" onClick={(e) => this.setEyeControl('new-password')}></i>;
        } else {
            $("#new-password").addClass("set-password");
            return <i className="far fa-eye-slash i-hide" onClick={(e) => this.setEyeControl('new-password')}></i>;
        }
    }

    eyeControlRePassword() {
        if ( this.state.show_re_password ) {
            $("#re-password").removeClass("set-password");
            return <i className="far fa-eye i-show" onClick={(e) => this.setEyeControl('re-password')}></i>;
        } else {
            $("#re-password").addClass("set-password");
            return <i className="far fa-eye-slash i-hide" onClick={(e) => this.setEyeControl('re-password')}></i>;
        }
    }

    setEyeControl = (e) => {
        if ( e === "new-password" ) {
            if ( this.state.show_password ) {
                $("#re-password").removeClass("set-password");
                this.setState({ show_password: false });
            } else {
                $("#re-password").addClass("set-password");
                this.setState({ show_password: true });
            }
        } else {
            if ( this.state.show_re_password ) {
                $("#re-password").removeClass("set-password");
                this.setState({ show_re_password: false });
            } else {
                $("#re-password").addClass("set-password");
                this.setState({ show_re_password: true });
            }
        }
    }

    Submit = () => {
        if ( this.state.password !== this.state.re_password ) {
            _Alert('รหัสผ่านไม่ตรงกัน');
            return;
        } 
        if ( this.state.password.length !== 6 || this.state.re_password.length !== 6 ) {
            _Alert('รหัสผ่านไม่ครบ 6 ตัวอักษร');
            return;
        } 

        this.setState({ loadingShow: true });

        var param = { account_id: this.props.AccountID, password: this.state.re_password, via: 'website' };
        _post('set.password.php', param).then(res => { 
            this.setState({ loadingShow: false });
            if ( res.data.status ) {
                const MySwal = withReactContent(Swal);
                MySwal.fire({ 
                    title: 'สมัครใช้งานสำเร็จ', 
                    text: 'สามารถเข้าใช้งานผ่านเว็บไซต์ออนไลน์',
                    type: 'success'
                }).then((result) => {
                    if ( result.value ) this.context.router.history.push('/online');
                });
            } else {
                _Alert('modify', 'error', 'พบข้อผิดพลาด', res.data.responseText);
            }
        }).catch(err => { 
            this.setState({ loadingShow: false });
            _Alert('error'); 
        });
    }

    render() {
        return (
            <div>
                <Loading show={this.state.loadingShow} />
                <div className="register-row">
                    <div className="otp-title">กรุณาตั้งรหัสผ่านสำหรับเข้าสู่ระบบ</div>
                </div>
                <div className="register-otp">
                    <div className="input-group mb-3 txt-input">
                        <div className="input-group-prepend">
                            <span className="input-group-text" id="basic-addon1"><i className="fas fa-key pass"></i></span>
                        </div>
                        <InputMask className="form-control" id="new-password" mask="999999" maskChar={null} placeholder="รหัสผ่าน" value={this.state.password} onChange={(e) => this.update("password", e)} />
                        {this.eyeControlPassword()}
                    </div>
                </div>
                <div className="register-otp">
                    <div className="input-group mb-3 txt-input">
                        <div className="input-group-prepend">
                            <span className="input-group-text" id="basic-addon1"><i className="fas fa-key pass"></i></span>
                        </div>
                        <InputMask className="form-control" id="re-password" mask="999999" maskChar={null} placeholder="รหัสผ่านอีกครั้ง" value={this.state.re_password} onChange={(e) => this.update("re_password", e)} />
                        {this.eyeControlRePassword()}
                    </div>
                </div>
                <div className="register-row btn-row">
                    <button type="button" className="btn btn-light btn-lg" onClick={(e) => this.Submit()}>ตั้งรหัสผ่าน</button>
                </div> 
            </div>
        )
    }
}

export default RegisterPassword;